import React from 'react';
import classNames from '../../../../utility/classNames';

export default function LegacyCalculatedField({
  field,
  percentageValue,
  annualValue,
  fieldValue,
  labelElement,
  percentToDisplay,
  monthlyToDisplay,
  annualToDisplay,
}) {
  const { formula, dynamic, total } = field;

  return (
    <div
      className={classNames(
        'grid grid-cols-5 justify-items-end sm:gap-4 lg:gap-1 xl:gap-3'
      )}
    >
      {/* Label for the field */}
      <div
        className={classNames(
          'h-full flex col-span-5 sm:col-span-2 justify-self-start'
        )}
      >
        {labelElement}
      </div>

      {/* Percent Value */}
      <div className="w-full col-span-5 sm:col-span-1">
        {percentageValue && (
          <div
            className={classNames(
              'w-full relative sm:max-w-xs h-full flex items-center pl-1',
              formula ? 'justify-between' : 'justify-between sm:justify-end'
            )}
          >
            <span className={classNames('text-sm sm:hidden font-normal')}>
              %
            </span>
            <span
              className={classNames(
                'flex w-full justify-end',
                formula && 'sm:justify-between'
              )}
            >
              {percentToDisplay}
            </span>
          </div>
        )}
      </div>

      {/* Monthly Value (usually the default) */}
      <div className="w-full col-span-5 sm:col-span-1">
        {total && <hr className="mb-0.5 border border-neutral-400" />}
        <div
          className={classNames(
            'w-full relative sm:max-w-xs h-full flex items-center pl-1',
            formula ? 'justify-between' : 'justify-between sm:justify-end',
            dynamic && fieldValue < 0 && 'text-red-700',
            dynamic && fieldValue > 0 && 'text-green-700'
          )}
        >
          <span className={classNames('text-sm sm:hidden font-normal')}>
            Monthly:
          </span>
          <span
            className={classNames(
              'flex w-full justify-end',
              formula && 'sm:justify-between'
            )}
          >
            {monthlyToDisplay}
          </span>
        </div>
      </div>

      {/* Annual value */}
      {annualValue && (
        <div className="w-full col-span-5 sm:col-span-1">
          {total && (
            <hr className="hidden sm:flex mb-0.5 border border-neutral-400" />
          )}
          <div
            className={classNames(
              'w-full relative sm:max-w-xs h-full flex items-center pl-1 col-span-5 sm:col-span-1',
              formula ? 'justify-between' : 'justify-between sm:justify-end'
            )}
          >
            <span className="text-sm sm:hidden font-normal">Annual:</span>
            <span
              className={classNames(
                'flex w-full justify-end',
                formula && 'sm:justify-between'
              )}
            >
              {annualToDisplay}
            </span>
          </div>
        </div>
      )}
    </div>
  );
}
